import { classListSupport, hasClass } from './hasClass.js';
var removeClass = classListSupport ?
    function (el, str) {
      if (hasClass(el,  str)) { el.classList.remove(str); }
    } :
    function (el, str) {
      if (hasClass(el, str)) { el.className = el.className.replace(str, ''); }
    };

export { removeClass };


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/removeClass.js
// module id = 1090
// module chunks = 0